module.exports = __webpack_public_path__ + "img/cgbh-logo.7d5cef24.png";